import {logConversionsConstants} from "../constants/logConversionsConstants";

const initialState = {
    data: {
        records: [],
        page: 0,
        recordsPerPage: 0,
        recordsReturned: 0,
        totalRecords: 0
    },
    errorMsg: "",
    isLoading: false,
    clickId: "",
    orderBy: "",
    sortBy: "",
    sortColumns: [],
    rerender: false
};

const logConversionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case logConversionsConstants.LOG_CONVERSIONS_SET_IS_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case logConversionsConstants.LOG_CONVERSIONS_INFINITY_SCROLL:
            return {
                ...state,
                data: {
                    records: [...state.data.records, ...action?.result?.records],
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    recordsReturned: action?.result?.recordsReturned,
                    totalRecords: action?.result?.totalRecords
                },
                errorMsg: '',
                isLoading: false
            };
        case logConversionsConstants.LOG_CONVERSIONS_LOADING:
            return {
                ...state,
                data: {
                    records: action?.result?.records,
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    recordsReturned: action?.result?.recordsReturned,
                    totalRecords: action?.result?.totalRecords
                },
                errorMsg: '',
                isLoading: false,
                rerender: false
            };
        case logConversionsConstants.LOG_CONVERSIONS_LOADING_ERROR:
            return {
                ...state,
                errorMsg: 'Unable to load conversions log.',
                isLoading: false,
            };
        case logConversionsConstants.LOG_CONVERSIONS_UPDATE_ORDER_BY:
            return {
                ...state,
                orderBy: action.orderBy
            };
        case logConversionsConstants.LOG_CONVERSIONS_UPDATE_SORT_BY:
            return {
                ...state,
                sortBy: action.sortBy
            };
        case logConversionsConstants.LOG_CONVERSIONS_UPDATE_CLICK_ID:
            return {
                ...state,
                clickId: action.clickId
            };
        case logConversionsConstants.LOG_CONVERSIONS_UPDATE_SORT_COLUMNS:
            return {
                ...state,
                sortColumns: action.sortColumns
            };
        case logConversionsConstants.LOG_CONVERSIONS_RERENDER:
            return {
                ...state,
                rerender: true
            };
        default:
            return state;
    }
};

export default logConversionsReducer;